var _desc, _style, _g, _path, _path2, _path3, _circle, _circle2, _defs, _desc2, _style2, _g2, _circle3, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconOrb2 = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 122,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    className: className,
    height: height,
    ref: ref
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "orb2-title"
  }, "Render Deployment Orb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "orb2-title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "orb2-desc"
  }, "An animated orbital design representing Render deployment options. Features an orange circle that travels horizontally with a perspective effect, symbolizing deployment connectivity and movement.")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @media (prefers-reduced-motion: reduce) {\n      * {\n        animation-duration: 0.01ms !important;\n        animation-iteration-count: 1 !important;\n        transition-duration: 0.01ms !important;\n      }\n    }\n    \n    @media (prefers-contrast: high) {\n      circle[fill=\"rgb(var(--color-brand-accent))\"] {\n        fill: #FF0000 !important;\n        stroke: #000000 !important;\n        stroke-width: 1px !important;\n      }\n    }\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0645 60.9983C18.0645 65.576 14.3535 69.287 9.77578 69.287C5.19804 69.287 1.48704 65.576 1.48704 60.9983C1.48704 56.4205 5.19804 52.7095 9.77578 52.7095C14.3535 52.7095 18.0645 56.4205 18.0645 60.9983Z",
    stroke: "url(#paint0_linear_13920_40265)",
    strokeDasharray: "0.39 1.96 0.78 1.96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.669 60.9986C25.669 67.677 20.2551 73.0909 13.5767 73.0909C6.8983 73.0909 1.48437 67.677 1.48438 60.9986C1.48438 54.3202 6.8983 48.9062 13.5767 48.9062C20.2551 48.9062 25.669 54.3202 25.669 60.9986Z",
    stroke: "url(#paint1_linear_13920_40265)",
    strokeDasharray: "0.39 1.96 0.78 1.96"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.8114 61.0001C83.8114 83.7344 65.3816 102.164 42.6473 102.164C19.913 102.164 1.48313 83.7344 1.48313 61.0001C1.48313 38.2658 19.913 19.8359 42.6473 19.8359C65.3816 19.8359 83.8114 38.2658 83.8114 61.0001Z",
    stroke: "currentColor",
    strokeDasharray: "2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.854 60.9993C101.854 88.7168 79.3847 111.186 51.6673 111.186C23.9499 111.186 1.48047 88.7168 1.48047 60.9993C1.48047 33.2819 23.9499 10.8125 51.6673 10.8125C79.3847 10.8125 101.854 33.2819 101.854 60.9993Z",
    stroke: "currentColor",
    strokeDasharray: "2 2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.48313 61.0041C1.48313 74.0344 12.0462 84.5974 25.0764 84.5974C38.1066 84.5974 48.6697 74.0344 48.6697 61.0041C48.6697 47.9739 38.1066 37.4109 25.0764 37.4109C12.0462 37.4109 1.48313 47.9739 1.48313 61.0041ZM1.48313 61.0041C1.48313 81.2685 17.9106 97.6962 38.175 97.6962C58.4393 97.6962 74.8668 81.2687 74.8668 61.0043C74.8668 40.74 58.4393 24.3125 38.175 24.3125C17.9106 24.3125 1.48313 40.7398 1.48313 61.0041ZM1.48313 61.0041C1.48313 86.3198 22.0055 106.843 47.3211 106.843C72.6367 106.843 93.1591 86.3202 93.1591 61.0045C93.1591 35.6889 72.6367 15.1665 47.3211 15.1665C22.0055 15.1665 1.48313 35.6885 1.48313 61.0041ZM1.48313 61.0041C1.48313 91.4944 26.2004 116.212 56.6907 116.212C87.181 116.212 111.898 91.4947 111.898 61.0044C111.898 30.5141 87.181 5.79688 56.6907 5.79688C26.2004 5.79687 1.48313 30.5139 1.48313 61.0041ZM32.7003 61.0022C32.7003 69.6216 25.713 76.6089 17.0937 76.6089C8.47437 76.6089 1.48704 69.6216 1.48704 61.0022C1.48704 52.3829 8.47437 45.3956 17.0937 45.3956C25.713 45.3956 32.7003 52.3829 32.7003 61.0022ZM40.3606 61.0004C40.3606 71.7369 31.657 80.4405 20.9205 80.4405C10.1841 80.4405 1.48047 71.7369 1.48047 61.0004C1.48047 50.264 10.1841 41.5604 20.9205 41.5604C31.657 41.5604 40.3606 50.264 40.3606 61.0004ZM57.6157 61.0027C57.6157 76.5033 45.05 89.069 29.5494 89.069C14.0488 89.069 1.48313 76.5033 1.48313 61.0027C1.48313 45.5021 14.0488 32.9364 29.5494 32.9364C45.05 32.9364 57.6157 45.5021 57.6157 61.0027ZM65.9222 61.0011C65.9222 78.7955 51.497 93.2206 33.7026 93.2206C15.9083 93.2206 1.48313 78.7955 1.48313 61.0011C1.48313 43.2068 15.9083 28.7816 33.7026 28.7816C51.497 28.7816 65.9222 43.2068 65.9222 61.0011Z",
    stroke: "currentColor",
    strokeDasharray: "0.39 1.96 0.78 1.96"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61.4844,
    cy: 61,
    r: 60,
    stroke: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 61,
    r: 4,
    fill: "rgb(var(--color-brand-accent))"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "8s",
    repeatCount: "indefinite",
    path: "M 0 0 L 85 0 L 0 0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "4;2;4",
    dur: "8s",
    repeatCount: "indefinite"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13920_40265",
    x1: 13.5767,
    y1: 32.0614,
    x2: 13.5767,
    y2: 68.4155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.371795,
    stopColor: "#15252D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.650713,
    stopColor: "#FFEADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70919,
    stopColor: "#FFEADB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13920_40265",
    x1: 13.5767,
    y1: 32.0614,
    x2: 13.5767,
    y2: 68.4155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.371795,
    stopColor: "#15252D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.650713,
    stopColor: "#FFEADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70919,
    stopColor: "#FFEADB",
    stopOpacity: 0
  })))));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 122,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 122 122",
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    className: className,
    height: height,
    ref: ref
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "orb2-title"
  }, "Render Deployment Orb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "orb2-title"
  }, title) : null, _desc2 || (_desc2 = /*#__PURE__*/React.createElement("desc", {
    id: "orb2-desc"
  }, "An animated orbital design representing Render deployment options. Features an orange circle that travels horizontally with a perspective effect, symbolizing deployment connectivity and movement.")), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", null, "\n    @media (prefers-reduced-motion: reduce) {\n      * {\n        animation-duration: 0.01ms !important;\n        animation-iteration-count: 1 !important;\n        transition-duration: 0.01ms !important;\n      }\n    }\n    \n    @media (prefers-contrast: high) {\n      circle[fill=\"rgb(var(--color-brand-accent))\"] {\n        fill: #FF0000 !important;\n        stroke: #000000 !important;\n        stroke-width: 1px !important;\n      }\n    }\n  ")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0645 60.9983C18.0645 65.576 14.3535 69.287 9.77578 69.287C5.19804 69.287 1.48704 65.576 1.48704 60.9983C1.48704 56.4205 5.19804 52.7095 9.77578 52.7095C14.3535 52.7095 18.0645 56.4205 18.0645 60.9983Z",
    stroke: "url(#paint0_linear_13920_40265)",
    strokeDasharray: "0.39 1.96 0.78 1.96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.669 60.9986C25.669 67.677 20.2551 73.0909 13.5767 73.0909C6.8983 73.0909 1.48437 67.677 1.48438 60.9986C1.48438 54.3202 6.8983 48.9062 13.5767 48.9062C20.2551 48.9062 25.669 54.3202 25.669 60.9986Z",
    stroke: "url(#paint1_linear_13920_40265)",
    strokeDasharray: "0.39 1.96 0.78 1.96"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M83.8114 61.0001C83.8114 83.7344 65.3816 102.164 42.6473 102.164C19.913 102.164 1.48313 83.7344 1.48313 61.0001C1.48313 38.2658 19.913 19.8359 42.6473 19.8359C65.3816 19.8359 83.8114 38.2658 83.8114 61.0001Z",
    stroke: stroke,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.854 60.9993C101.854 88.7168 79.3847 111.186 51.6673 111.186C23.9499 111.186 1.48047 88.7168 1.48047 60.9993C1.48047 33.2819 23.9499 10.8125 51.6673 10.8125C79.3847 10.8125 101.854 33.2819 101.854 60.9993Z",
    stroke: stroke,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.48313 61.0041C1.48313 74.0344 12.0462 84.5974 25.0764 84.5974C38.1066 84.5974 48.6697 74.0344 48.6697 61.0041C48.6697 47.9739 38.1066 37.4109 25.0764 37.4109C12.0462 37.4109 1.48313 47.9739 1.48313 61.0041ZM1.48313 61.0041C1.48313 81.2685 17.9106 97.6962 38.175 97.6962C58.4393 97.6962 74.8668 81.2687 74.8668 61.0043C74.8668 40.74 58.4393 24.3125 38.175 24.3125C17.9106 24.3125 1.48313 40.7398 1.48313 61.0041ZM1.48313 61.0041C1.48313 86.3198 22.0055 106.843 47.3211 106.843C72.6367 106.843 93.1591 86.3202 93.1591 61.0045C93.1591 35.6889 72.6367 15.1665 47.3211 15.1665C22.0055 15.1665 1.48313 35.6885 1.48313 61.0041ZM1.48313 61.0041C1.48313 91.4944 26.2004 116.212 56.6907 116.212C87.181 116.212 111.898 91.4947 111.898 61.0044C111.898 30.5141 87.181 5.79688 56.6907 5.79688C26.2004 5.79687 1.48313 30.5139 1.48313 61.0041ZM32.7003 61.0022C32.7003 69.6216 25.713 76.6089 17.0937 76.6089C8.47437 76.6089 1.48704 69.6216 1.48704 61.0022C1.48704 52.3829 8.47437 45.3956 17.0937 45.3956C25.713 45.3956 32.7003 52.3829 32.7003 61.0022ZM40.3606 61.0004C40.3606 71.7369 31.657 80.4405 20.9205 80.4405C10.1841 80.4405 1.48047 71.7369 1.48047 61.0004C1.48047 50.264 10.1841 41.5604 20.9205 41.5604C31.657 41.5604 40.3606 50.264 40.3606 61.0004ZM57.6157 61.0027C57.6157 76.5033 45.05 89.069 29.5494 89.069C14.0488 89.069 1.48313 76.5033 1.48313 61.0027C1.48313 45.5021 14.0488 32.9364 29.5494 32.9364C45.05 32.9364 57.6157 45.5021 57.6157 61.0027ZM65.9222 61.0011C65.9222 78.7955 51.497 93.2206 33.7026 93.2206C15.9083 93.2206 1.48313 78.7955 1.48313 61.0011C1.48313 43.2068 15.9083 28.7816 33.7026 28.7816C51.497 28.7816 65.9222 43.2068 65.9222 61.0011Z",
    stroke: stroke,
    strokeDasharray: "0.39 1.96 0.78 1.96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.4844,
    cy: 61,
    r: 60,
    stroke: stroke
  }), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 61,
    r: 4,
    fill: "rgb(var(--color-brand-accent))"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "8s",
    repeatCount: "indefinite",
    path: "M 0 0 L 85 0 L 0 0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "4;2;4",
    dur: "8s",
    repeatCount: "indefinite"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13920_40265",
    x1: 13.5767,
    y1: 32.0614,
    x2: 13.5767,
    y2: 68.4155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.371795,
    stopColor: "#15252D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.650713,
    stopColor: "#FFEADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70919,
    stopColor: "#FFEADB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13920_40265",
    x1: 13.5767,
    y1: 32.0614,
    x2: 13.5767,
    y2: 68.4155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.371795,
    stopColor: "#15252D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.650713,
    stopColor: "#FFEADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70919,
    stopColor: "#FFEADB",
    stopOpacity: 0
  })))));
});
export default SvgIconOrb2;
export const raw = __webpack_public_path__ + "static/media/icon-orb-2.5d2cbc02f3423394959859af6ed81b1d.svg";